import {
    Empty,
    EmptyDescription,
    EmptyHeader,
    EmptyMedia,
    EmptyTitle,
} from "@/components/ui/empty";

interface EmptySectionStateProps {
    icon: React.ElementType;
    title: string;
    description: string;
}

export const EmptySectionState = ({
    icon: Icon,
    title,
    description,
}: EmptySectionStateProps) => (
    <Empty className="border-none py-4">
        <EmptyHeader>
            <EmptyMedia variant="icon">
                <Icon />
            </EmptyMedia>
            <EmptyTitle>{title}</EmptyTitle>
            <EmptyDescription>{description}</EmptyDescription>
        </EmptyHeader>
    </Empty>
);
